import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-forbidden",
  "use": "icon-forbidden-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-forbidden\"><path d=\"M512 50.112a461.888 461.888 0 1 0 0 923.776A461.888 461.888 0 0 0 512 50.112zM120.512 512a391.488 391.488 0 1 1 782.976 0A391.488 391.488 0 0 1 120.512 512zM288 476.8a35.2 35.2 0 0 0 0 70.4h448a35.2 35.2 0 1 0 0-70.4h-448z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol